import { useQuery, useQueryClient } from "@tanstack/react-query";
import { portalApiClient } from "src/api/apiClient";
import { EntityUpdate } from "src/types/EntityUpdate";

export default function useServiceStatus() {
  const queryClient = useQueryClient();
  const queryKeys = ["serviceStatus"];
  const query = useQuery({
    queryKey: queryKeys,
    queryFn: () =>
      portalApiClient
        .get<EntityUpdate>("/api/ServiceStatus/EntityUpdates")
        .then((res) => res.data),
    // refetchInterval: 20 * 1000,
  });
  return {
    ...query,
    invalidate: () => queryClient.invalidateQueries({ queryKey: queryKeys }),
  };
}
